import { Button } from "@narmi/design_system";
import { memo } from "react";

const PositivePayItem = () => (
  <Button as="a" label="Positive Pay" kind="menu" href="/positive_pay" />
);

export default memo(PositivePayItem);
